import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import {
  Drawer,
  Paper,
  Button,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';
import _ from 'lodash';
// simport React, { PureComponent } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import Loader from '../common/customLoader';
import { languageConverter } from '../../Functions/helper';

const TemporaryDrawer = (props) => {
  const {
    farmStats,
    weatherData,
    nearbyData,
    language,
    openRegisterModal,
    ndviTimelineData,
    levelStatsFetching,
    farmDetails,
    reportBoundaryError,
    flag,
    newFlag,
  } = props;
  const { generalStats } = farmStats;
  let weatherStats = {};
  if (weatherData.length) {
    [weatherStats] = weatherData;
  }

  const {
    farmArea,
    farmrating,
    cropName,
    ndvi,
    harvestDate,
    sowingDate,
    irrigation,
    cropHealth,
    yield: yieldData,
  } = generalStats;
  const isFarmParameterVisible = harvestDate || sowingDate || irrigation || cropHealth || yieldData;
  console.log('New Data', isFarmParameterVisible);
  const { icName, sumInsured, premium } = farmDetails;
  const fullList = () => (
    <div className="fullList drawerController" role="presentation">
      <h4 className="drawerHeading">
        {languageConverter('Farm Profile', language.hindi)}

        <div
          className="crossIcon"
          role="button"
          onClick={() => props.closeFarmCard()}
          tabIndex={0}
          onKeyPress={() => props.closeFarmCard()}
        >
          <i className="material-icons">
            {' '}
            {(language.hindi && language.hindi.close) || 'close'}
            {' '}
          </i>
        </div>
      </h4>
      <Paper
        className={
          'paper'
          + ' '
          + 'commonStatPanel'
          + ' '
          + 'commonPadding'
          + ' '
          + 'removeBoxShadow'
        }
      >
        <ul>
          {cropName ? (
            <li>
              {languageConverter('Crop Name', language.hindi)}
              <span>{languageConverter(cropName, language.hindi)}</span>
            </li>
          ) : null}
          {farmArea ? (
            <li>
              {languageConverter('Farm Area', language.hindi)}
              <span>
                {`${Math.floor((farmArea / 10000) * 10000) / 10000} ha`}
              </span>
            </li>
          ) : null}
          {farmrating ? (
            <li>
              {languageConverter('Avg. Farm Ratings', language.hindi)}
              <span>{Math.floor(farmrating * 10000) / 10000}</span>
            </li>
          ) : null}
          {ndvi ? (
            <li>
              {languageConverter('Ndvi', language.hindi)}
              <span>{Math.floor(ndvi * 10000) / 10000}</span>
            </li>
          ) : null}

          {/* {sowingDate ? ( */}
          {/* <li> */}
          {/* {languageConverter('Sowing Date', language.hindi)} */}
          {/* <span>{sowingDate}</span> */}
          {/* </li> */}
          {/* ) : null} */}
          {/* {irrigation ? ( */}
          {/* <li> */}
          {/* {languageConverter('Irrigation Type', language.hindi)} */}

          {/* <span>{irrigation}</span> */}
          {/* </li> */}
          {/* ) : null} */}
          {/* {harvestDate ? ( */}
          {/* <li> */}
          {/* {languageConverter('Harvest Date', language.hindi)} */}
          {/* <span>{harvestDate}</span> */}
          {/* </li> */}
          {/* ) : null} */}
        </ul>
        {/* Weather Report Start */}
        {/* <div className="fieldDepartment"> */}
        {/* <h5>NDVI Chart</h5> */}
        {/* <div className="analyticsStats"> */}
        {/* <ul> */}
        {/* {ndvi ? ( */}
        {/* <li> */}
        {/* {languageConverter('Ndvi', language.hindi)} */}
        {/* <span>{Math.floor(ndvi * 10000) / 10000}</span> */}
        {/* </li> */}
        {/* ) : null} */}
        {/* </ul> */}
        {/* </div> */}
        {/* </div> */}
        {isFarmParameterVisible && (
          <div className="fieldDepartment">
            <h5>{languageConverter('Farm Parameters', language.hindi)}</h5>
            <ul>
              {sowingDate ? (
                <li className="">
                  {languageConverter('Sowing Date', language.hindi)}
                  <span>{sowingDate}</span>
                </li>
              ) : null}
              {harvestDate ? (
                <li className="">
                  {languageConverter('Harvest Date', language.hindi)}
                  <span>{harvestDate}</span>
                </li>
              ) : null}
              {irrigation ? (
                <li className="">
                  {languageConverter('Irrigation', language.hindi)}
                  <span>{irrigation}</span>
                </li>
              ) : null}
              {cropHealth ? (
                <li className="">
                  {languageConverter('Crop Health', language.hindi)}
                  <span>{_.capitalize(cropHealth)}</span>
                </li>
              ) : null}
              {yieldData ? (
                <li className="">
                  {languageConverter('Yield', language.hindi)}
                  <span>
                    {yieldData}
                    {' '}
MT/ha
                  </span>
                </li>
              ) : null}
            </ul>
          </div>
        )}
        <div className="fieldDepartment">
          <h5>{languageConverter('Distance Mapping', language.hindi)}</h5>
          <ul>
            {nearbyData.marketName ? (
              <li className="fullWidth">
                {languageConverter('Nearest Market', language.hindi)}
                <strong>
                  {' '}
                  {nearbyData.marketDistance
                    ? ` - ${Math.round(
                      (nearbyData.marketDistance / 1000) * 100,
                    ) / 100} ${languageConverter('kms away', language.hindi)}`
                    : ''}
                </strong>
                <span>{nearbyData.marketName}</span>
              </li>
            ) : null}
            {nearbyData.bankName ? (
              <li className="fullWidth">
                {languageConverter('Nearest Bank', language.hindi)}
                <strong>
                  {nearbyData.bankDistance
                    ? ` - ${Math.round((nearbyData.bankDistance / 1000) * 100)
                        / 100} ${languageConverter('kms away', language.hindi)}`
                    : ''}
                </strong>
                <span>{nearbyData.bankName}</span>
              </li>
            ) : null}
            {nearbyData.storageName ? (
              <li className="fullWidth">
                {languageConverter('Nearest Storage', language.hindi)}
                <strong>
                  {nearbyData.storageDistance
                    ? ` - ${Math.round(
                      (nearbyData.storageDistance / 1000) * 100,
                    ) / 100} ${languageConverter('kms away', language.hindi)}`
                    : ''}
                </strong>
                <span>{nearbyData.storageName}</span>
              </li>
            ) : null}

            {nearbyData.waterwayName ? (
              <li className="fullWidth">
                {languageConverter('Nearest Waterway', language.hindi)}
                <strong>
                  {nearbyData.waterDistance
                    ? ` - ${Math.round(
                      (nearbyData.waterDistance / 1000) * 100,
                    ) / 100} ${languageConverter('kms away', language.hindi)}`
                    : ''}
                </strong>
                <span>{nearbyData.waterwayName}</span>
              </li>
            ) : null}
          </ul>
        </div>

        {icName ? (
          <div className="fieldDepartment">
            <h5>{languageConverter('Insurance Company', language.hindi)}</h5>
            <ul>
              <li className="">
                {languageConverter('Company', language.hindi)}
                <span>{icName}</span>
              </li>
              {sumInsured ? (
                <li className="">
                  {languageConverter('Sum Insured', language.hindi)}
                  <span>{sumInsured}</span>
                </li>
              ) : null}
              {premium ? (
                <li className="">
                  {languageConverter('Premium Amount', language.hindi)}
                  <span>{premium}</span>
                </li>
              ) : null}
            </ul>
          </div>
        ) : null}

        {weatherData.length ? (
          <div className="fieldDepartment">
            <h5>{languageConverter('Weather', language.hindi)}</h5>
            {ndviTimelineData.length ? (
              <h5>
                Last 90 days data of
                <FormControl className="formControl inputHead coloredForms">
                  <Select
                    name="select-year"
                    inputProps={{ 'aria-label': 'graph' }}
                    className="tableDropdown"
                    // onChange={event => this.handleYear(event.target.value)}
                    value="ndvi"
                    disableUnderline
                  >
                    <MenuItem value="" disabled>
                      {(language.hindi && language.hindi['Select Field'])
                        || 'Select Field'}
                    </MenuItem>
                    <MenuItem value="ndvi">Ndvi</MenuItem>
                  </Select>
                </FormControl>
              </h5>
            ) : null}
            {ndviTimelineData.length ? (
              <div className="graphSec">
                <LineChart width={280} height={300} data={ndviTimelineData}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="mode" stroke="#8884d8" />
                  {/* <Line type="monotone" dataKey="mean" stroke="#82ca9d" />
                                 <Line type="monotone" dataKey="median" stroke="#000"/>
                                 <Line type="monotone" dataKey="min" stroke="#rrr" /> */}
                </LineChart>
                {/* <img src="images/extra/graph.svg" alt="graph" title="graph" /> */}
              </div>
            ) : null}
          </div>
        ) : null}
        {/* Weather Report Start */}
        {Object.keys(weatherStats).length ? (
          <div className="root weatherReportSec commonPadding">
            <img
              src={weatherStats.weather.icon}
              alt="weather-report"
              title="weather-report"
            />
            <h6>
              {weatherStats.temperature}
              <span>
                {languageConverter('Wind Speed', language.hindi)}
                <i>
                  {` ${weatherStats.wind.speed}${languageConverter(
                    'km/hr',
                    language.hindi,
                  )}`}
                </i>
                {' '}
              </span>
            </h6>
            {/* <div className="villageInfo">
                    Samastipur Village
                    <span>Scattered Thundershowers</span>
                  </div> */}
          </div>
        ) : null}

        {/* Weather Report End */}
        <div
          className="root weatherReportSec commonPadding"
          style={{ paddingBottom: '30px' }}
        >
          {flag ? (
            <span>
              {languageConverter('Wrong field boundaries ?', language.hindi)}
              <Button
                style={{ color: '#09b466' }}
                onClick={() => {
                  reportBoundaryError(1);
                }}
              >
                {' '}
                {languageConverter('Inform Us', language.hindi)}
              </Button>
            </span>
          ) : (
            <span>{languageConverter('Thank you', language.hindi)}</span>
          )}
        </div>
        <div
          className="root weatherReportSec commonPadding"
          style={{ paddingBottom: '10px' }}
        >
          {newFlag ? (
            <span>
              {languageConverter('Wrong Crop ?', language.hindi)}
              <Button
                style={{ color: '#09b466' }}
                onClick={() => {
                  reportBoundaryError(2);
                }}
              >
                {' '}
                {languageConverter('Inform Us', language.hindi)}
              </Button>
            </span>
          ) : (
            <span>{languageConverter('Thank you', language.hindi)}</span>
          )}
        </div>
      </Paper>

      <div className="drawerFixedSec siFoloBtnHeader">
        <Button
          variant="contained"
          className="button siFoloBtn"
          onClick={() => openRegisterModal(true)}
        >
          {languageConverter('Click to register', language.hindi)}
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      <Drawer anchor="bottom" open>
        {!levelStatsFetching ? fullList('bottom') : <Loader />}
      </Drawer>
    </div>
  );
};

export default TemporaryDrawer;
